import {
  ApButtonGroup,
  ApButtonMain,
  ApIcon,
  ApModal,
} from '@alixpartners/ui-components';

interface Props {
  title: string;
  isOpen?: boolean;
  message: string;
  disabled?: boolean;
  mainBtnText?: string;
  onClose?: () => void;
}

export const InfoModal = ({
  title,
  message,
  isOpen = true,
  disabled = false,
  mainBtnText = 'Ok',
  onClose,
}: Props) => {
  return (
    <ApModal
      isDismissible={false}
      isFluid={false}
      isOpen={isOpen}
      zIndex={998}
      hasClosed={onClose}
      footer={() => (
        <ApButtonGroup justifyContent="space-between">
          <ApButtonMain onClick={onClose} disabled={disabled}>
            {mainBtnText}
          </ApButtonMain>
        </ApButtonGroup>
      )}
    >
      <h3 style={customHeaderStyle}>
        <ApIcon iconName="outline_info" iconColor="orange" iconSize={24} />
        {title}
      </h3>
      <div>{message}</div>
    </ApModal>
  );
};

const customHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  textIndent: '8px',
};
